export default __webpack_public_path__ + "static/media/policy-cluster.43e47e7d.svg";